import React from 'react';
import ReactMarkdown from 'react-markdown';
import './index.scss';
import remarkSlug from 'remark-slug';
interface MarkdownRendererProps {
  content: string;
}
const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  content
}) => {
  const renderers = {
    heading: (props: {
      children: React.ReactNode;
      level: number;
    }) => {
      const slugId = (props.children as any)[0]?.toString().toLowerCase().replace(/\s+/g, '-');
      return React.createElement(`h${props.level}`, {
        id: slugId,
        className: 'markdown-heading'
      }, props.children);
    }
  };
  return <div className="markdown" data-sentry-component="MarkdownRenderer" data-sentry-source-file="index.tsx">
      {/* @ts-ignore */}
      <ReactMarkdown className='markdownContent' remarkPlugins={[remarkSlug]} components={renderers} data-sentry-element="ReactMarkdown" data-sentry-source-file="index.tsx">
        {content}
      </ReactMarkdown>
    </div>;
};
export default MarkdownRenderer;